import { create } from 'zustand';
import { emit } from '@/lib/events';

export type ChoroplethMode = 'choropleth' | 'heatmap';

interface ChoroplethState {
  activeLayer: string;
  mode: ChoroplethMode;
  // Ручной тоггл: скрыть цветную заливку фильтра у всех регионов.
  // Locked-регион сохраняет hatch. Автоматически также срабатывает
  // на больших зумах через style-функцию (см. fillOpacityScale).
  overlayHidden: boolean;
  // Рельеф: hillshade-оверлей поверх подложки.
  terrainVisible: boolean;
  setActiveLayer: (key: string) => void;
  setMode: (mode: ChoroplethMode) => void;
  toggleOverlayHidden: () => void;
  toggleTerrainVisible: () => void;
}

export const useChoroplethStore = create<ChoroplethState>((set, get) => ({
  activeLayer: 'altitude',
  mode: 'choropleth',
  overlayHidden: false,
  terrainVisible: false,
  setActiveLayer: (key) => {
    const from = get().activeLayer;
    if (from === key) return;
    set({ activeLayer: key });
    emit('layer:changed', { from, to: key });
  },
  setMode: (mode) => set({ mode }),
  toggleOverlayHidden: () => set((s) => ({ overlayHidden: !s.overlayHidden })),
  toggleTerrainVisible: () => set((s) => ({ terrainVisible: !s.terrainVisible })),
}));
